module.exports = __webpack_public_path__ + "components/about-header/static/header--huge@2x-483cc9c0275aca7db88f58d6aac349dc.jpg";